module.exports = __webpack_public_path__ + "static/77-592ff3ad9715ee67b4318b656f215e7f.jpg";